import { getRoot, Instance, types } from 'mobx-state-tree'

export interface IRootAccessing extends Instance<typeof RootAccessing> {}

export const RootAccessing = types.model().views((self) => ({
  get rootStore(): any {
    return getRoot(self)
  },
}))
